import { useMemo } from "react";
import DOMPurify from "dompurify";

const ALLOWED_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];

if (typeof window !== "undefined") {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName?.toLowerCase() === "a") {
      const target = node?.getAttribute("target");

      if (!target) {
        node.setAttribute("target", "_blank");
      }
      node.setAttribute("rel", "noopener noreferrer");
    }
  });

  DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    if (data.attrName === "href") {
      try {
        const url = new URL(data.attrValue, window.location.href);
        if (!ALLOWED_PROTOCOLS.includes(url.protocol)) {
          data.keepAttr = false;
        }
      } catch {
        if (!data.attrValue?.startsWith("/")) {
          data.keepAttr = false;
        }
      }
    }
  });
}

const SANITIZE_CONFIG = {
  USE_PROFILES: { html: true },
  ALLOWED_TAGS: ["b", "i", "em", "strong", "a", "p", "ul", "ol", "li", "br"],
  ALLOWED_ATTR: ["href", "target", "rel"],
  FORBID_TAGS: ["style", "script"],
  FORBID_ATTR: ["style"],
  ALLOW_DATA_ATTR: false,
};

export default function SafeHtml({
  html,
  as: Component = "div",
  className = "",
}) {
  const clean = useMemo(() => {
    if (!html) return "";
    if (typeof window === "undefined") return "";
    return DOMPurify.sanitize(html, SANITIZE_CONFIG);
  }, [html]);

  return (
    <Component
      className={className}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html, SANITIZE_CONFIG),
      }}
    />
  );
}
